import robinPic from "@/public/images/artists/robin.png";
import { Artist } from "@/types/types";

export const robin = {
  id: "26",
  name: "Robin",
  image: robinPic,
  description: `Introducing "Robin," the powerhouse house singer with vocals that possess both might and depth. With a voice that commands attention, Robin infuses the world of house music with a resonating force. Her powerful vocals effortlessly blend with the pulsating beats, creating an electrifying fusion of sound.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Frobin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Soul", "Dance", "RnB", "Pop", "Disco"],
      secondary: ["Singer", "Powerful", "Original"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 52,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
